import { connectionApi } from '@api/connection/connection.api';

export const {
  useLazyLoadConnectionsQuery,
  useGetConnectionQuery,
  useSaveConnectionMutation,
  useSaveConnectionMetaMutation,
  useDeleteConnectionMutation,
} = connectionApi;
